import { Check } from 'react-feather'

import {
  Wrapper,
  Label,
  Colors,
  Color,
  Error,
} from './colorFieldStyle'

const ColorField = ({
  label,
  error,
  colors,
  onChange,
  value,
  ...props
}) => (
  <Wrapper {...props}>
    {label && <Label>{label}</Label>}

    <Colors role="listbox">
      {Object.keys(colors).map(color => (
        <Color
          role="option"
          type="button"
          key={color}
          onClick={() => onChange(color)}
          data-color={color}
          title={colors[color]}
          aria-selected={value === color}
        >{value === color && <Check />}</Color>
      ))}
    </Colors>

    {error && <Error>{error}</Error>}
  </Wrapper>
)

export default ColorField